var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useConfigContext } from '@m4b-design/config-provider';
import React, { useContext } from 'react';
import Button from '@m4b-design/button';
import { defaultRender } from './utils';
import { SearchAndFilterContext } from './context';
export function Triggers(props) {
    var config = useContext(SearchAndFilterContext);
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-search-and-filter-triggers");
    var _a = props.renderReset, renderReset = _a === void 0 ? defaultRender : _a, _b = props.renderSubmit, renderSubmit = _b === void 0 ? defaultRender : _b, _c = props.submitProps, submitProps = _c === void 0 ? {} : _c, _d = props.resetProps, resetProps = _d === void 0 ? {} : _d, disableDefaultReset = props.disableDefaultReset, disableDefaultSubmit = props.disableDefaultSubmit;
    return (React.createElement("div", { className: prefixCls },
        renderSubmit(React.createElement(Button, __assign({ type: "primary" }, submitProps, { onClick: function (e) {
                var _a;
                !disableDefaultSubmit && config.form.submit();
                (_a = submitProps.onClick) === null || _a === void 0 ? void 0 : _a.call(submitProps, e);
            } }), "Submit")),
        renderReset(React.createElement(Button, __assign({}, resetProps, { onClick: function (e) {
                var _a;
                !disableDefaultReset && config.form.resetFields();
                (_a = resetProps.onClick) === null || _a === void 0 ? void 0 : _a.call(resetProps, e);
            } }), "Reset"))));
}
